<template>
  <div class="app-container">
    <!-- 查询条件 -->
      <div ref="searchBox" class="formBox margbot">
        <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="100px" size="mini" style="width: 100%;">
          <div class="formItemBox">
          <el-form-item label="退款时间:">
            <div style="display: flex;">
           <el-date-picker v-model="formData.refundTimeStart" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>-
           <el-date-picker v-model="formData.refundTimeEnd" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="出库客户:">
           <el-select v-model="formData.outCustomerNameTaxId" size="mini" placeholder="请选择" filterable clearable>
              <el-option
                v-for="(item,index) in keHuOptions"
                :key="index"
                :label="item.showName"
                :value="item.itemNo">
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="出库单号:">
            <el-input v-model="formData.businessNo"  placeholder="请输入" size="mini" ></el-input>
          </el-form-item>
           <el-form-item label="原收款方式:">
           <el-select v-model="formData.oldCollectType" size="mini" placeholder="请选择" filterable clearable>
              <el-option
                v-for="(item,index) in SKMethods"
                :key="index"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          </div>
           <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[0]" btnCode="003P01kB001">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[1]" btnCode="003P01kB002">重置</el-button>
            <el-button type="primary" size="mini" @click="daochu" v-if="btnFlg[2]" btnCode="003P01kB003">导出</el-button>
          </el-form-item>
          <el-form-item>
             <span style="margin-left:10px;">合计：<span style="color: red">{{ heji }}</span> 元</span>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表格 -->
      <div :style="{ height: h }">
        <el-table
        height="100%"
        size="mini"
        border
        center
        bordersize="mini"
        ref="tabref1"
        :data="tableData"
        style="width: 100%"
        class="tableComent"
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        highlight-current-row
        @row-click="dianjixuanzhong"
      >
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="outCustomerName" label="出库客户" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="businessNo" label="出库单号" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="refundFee" label="退款金额" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="refundStateName" label="状态" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="refundTime" label="退款时间" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="oldCollectTypeName" label="原付款方式" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="paymentAccount" label="原付款账户" align="center" width="150"></el-table-column>
      </el-table>
      </div>
      <div class="pags" style="text-align: right">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="pageInfo.pageNo"
          :page-size="pageInfo.pageSize"
          :page-sizes="[10, 20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          :total="total"
        ></el-pagination>
      </div>
  </div>
</template>

<script>
import { getRefundRecordList, getRefundrecordAllfee } from '@/api/wms-stock'

import { exportExcel } from '@/utils/fileDown.js'
import {
  getQueryCusterData // 客户
} from '@/api/platform-settlement'
import { getBtn } from '@/utils/getButton'

export default {
  name: 'collectionSchedule',
  data () {
    return {
      formData: {
        refundTimeStart: '',
        refundTimeEnd: '',
        outCustomerNameTaxId: '',
        businessNo: '',
        oldCollectType: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      SKMethods: [
        { id: '', name: '全部' },
        { id: '1', name: '预存款' },
        { id: '2', name: '付款码' },
        { id: '3', name: '其他' }
      ],
      h: '500px',
      keHuOptions: [],
      tableData: [],
      xuanzhongArr: null,
      total: 0,
      heji: 0,
      btnFlg: [],
      btnIdArr: ['003P01kB001', '003P01kB002', '003P01kB003']
    }
  },
  methods: {
    chaxun () {
      this.pageInfo.pageNo = 1
      this.getRefundRecordLists()
    },
    getRefundRecordLists () {
      getRefundRecordList(
        {
          ...this.pageInfo,
          ...this.formData
        }
      )
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
          this.getRefundrecordAllfees()
        })
        .catch(error => {
          this.$message({ message: error.message, type: 'error' })
        })
    },
    getRefundrecordAllfees () {
      getRefundrecordAllfee({
        ...this.pageInfo,
        ...this.formData
      })
        .then(res => {
          this.heji = res.refundFee
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    chongzhi () {
      this.formData.refundTimeStart = ''
      this.formData.refundTimeEnd = ''
      this.formData.outCustomerNameTaxId = ''
      this.formData.businessNo = ''
      this.formData.oldCollectType = ''
      this.chaxun()
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/storageFee/exportRefundRecordList',
        { ...this.formData },
        '退款记录'
      )
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      // this.JfgetThreadDetailExpLists()
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.getRefundRecordLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.getRefundRecordLists()
    },
    // 获取所属客户数据
    getQueryCusterData () {
      getQueryCusterData().then(res => {
        this.keHuOptions = res
      }).catch(err => {
        this.$message({ message: err.message, type: 'error' })
      })
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 165 + 'px'
    this.btnFlg = getBtn(this.btnIdArr, '/refundRecord')
    this.chaxun()
    this.getQueryCusterData()
  }
}
</script>

<style lang="less" scoped>
.inpBox{
  .el-form-item{
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}

 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
